import React from "react";
import { vsiGreen } from "../utils/themeStyles";
import { VsiSpanText } from "../styled/App.styled";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

function DblClickText ({ children }) {
	return <VsiSpanText>
		{children && <i className="fa-solid fa-asterisk pe-1"
		   style={{ color: vsiGreen }}/>}
		{children || <span style={{ color: 'transparent' }}>Double click space</span>}
	</VsiSpanText>
}

export default withErrorBoundary(DblClickText, GeneralErrorBoundary);